import { render, staticRenderFns } from "./remoteVideo.vue?vue&type=template&id=d5fbd8b2&scoped=true&"
import script from "./remoteVideo.vue?vue&type=script&lang=js&"
export * from "./remoteVideo.vue?vue&type=script&lang=js&"
import style0 from "./remoteVideo.vue?vue&type=style&index=0&id=d5fbd8b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fbd8b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5fbd8b2')) {
      api.createRecord('d5fbd8b2', component.options)
    } else {
      api.reload('d5fbd8b2', component.options)
    }
    module.hot.accept("./remoteVideo.vue?vue&type=template&id=d5fbd8b2&scoped=true&", function () {
      api.rerender('d5fbd8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/remoteVideo.vue"
export default component.exports